import React, { Component } from "react";
import Theme from "../Theme.js";
import { DirectUpload } from "@rails/activestorage";
import imageCompression from 'browser-image-compression';

export default class FileUpload extends Component {
  state = {
    tempPhoto: null
  };
  getHeight(width) {
    if (width > 450) return 50;
    if (width > 400) return 50;
    if (width > 300) return 40;
    return 90;
  }
  getWidth(width) {
    if (width > 450) return 250;
    if (width > 400) return 140;
    if (width > 300) return 120;
    else return 60;
  }

  uploadFile = async event => {
    const url =
      import.meta.env.VITE_API_ENDPOINT +
      "/rails/active_storage/direct_uploads";

    let file = event.target.files[0];
    if (!file) {
      console.log('FileUpload - No file selected');
      return;
    }

    const originalType = file.type;
    const originalSize = file.size;

    // Handle camera captures that may have empty MIME type
    if (!file.type || file.type === '') {
      console.log('FileUpload - Empty MIME type detected, creating new File with image/jpeg');
      const fileName = file.name || `camera_${Date.now()}.jpg`;
      file = new File([file], fileName, { type: 'image/jpeg' });
    }

    // Check if it's an image type that should be compressed
    // Skip DNG, RAW, TIFF and other formats that browser-image-compression can't handle
    const compressibleTypes = [
      'image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/gif',
      'image/heic', 'image/heif', 'image/bmp'
    ];
    const compressibleExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.heic', '.heif', '.bmp'];
    const fileExt = file.name?.toLowerCase().match(/\.[^.]+$/)?.[0] || '';
    const isCompressible = compressibleTypes.includes(file.type?.toLowerCase()) ||
      compressibleExtensions.includes(fileExt);

    if (isCompressible) {
      const compressionOptions = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        fileType: 'image/jpeg' // Force output to JPEG for compatibility
      };

      console.log('FileUpload - Compressing image:', {
        originalType,
        originalSize,
        fileName: file.name
      });

      try {
        file = await imageCompression(file, compressionOptions);
        console.log('FileUpload - Compression complete:', {
          newType: file.type,
          newSize: file.size,
          compressionRatio: ((1 - file.size / originalSize) * 100).toFixed(1) + '%'
        });
      } catch (compressionError) {
        console.warn('FileUpload - Compression failed, using original:', compressionError);
      }
    } else {
      console.log('FileUpload - Skipping compression for unsupported format:', {
        fileType: file.type,
        fileName: file.name
      });
    }

    // Generate preview
    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({ tempPhoto: reader.result });
    };
    reader.readAsDataURL(file);

    // Upload file
    console.log('FileUpload - Starting upload:', {
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size,
      timestamp: new Date().toISOString()
    });

    const upload = new DirectUpload(file, url);
    upload.create((error, blob) => {
      if (error) {
        console.error('FileUpload - Upload error:', error);
        alert("Failed to upload file");
        return;
      }
      console.log('FileUpload - Upload successful:', { blobId: blob.id });
      this.props.onUpload(blob, reader.result);
    });
  };

  handleClick = event => {
    const { target = {} } = event || {};
    target.value = "";
  };

  render() {
    const { name, width, containerStyle, label } = this.props;
    // const width = obj.dimensions.width;
    const shrink = width < 568;
    return (
      <div style={containerStyle}>
        <input
          id={name}
          name={name}
          type="file"
          accept="image/*"
          style={{
            width: 0.1,
            height: 0.1,
            opacity: 0,
            overflow: "hidden",
            position: "absolute",
            zIndex: -1
          }}
          onChange={this.uploadFile}
          onClick={this.handleClick}
        />
        <label
          htmlFor={name}
          style={{
            display: "flex",
            flexDirection: "column",
            cursor: "pointer",
            backgroundColor: Theme.LINK_FONT_COLOR,
            // marginBottom: height / 100,
            borderRadius: 5,
            height: this.getHeight(width),
            width: shrink ? "fit-content" : this.getWidth(width),
            ...this.props.customStyle

          }}
        >
          <div
            style={{
              color: "white",
              fontSize: Theme.getSmallFont(width),
              fontFamily: Theme.HEADER_FONT,
              margin: "auto",
              padding: 10,
              textAlign: "center"
            }}
          >
            {label || "Upload Documents"}
          </div>
        </label>
      </div>
    );
  }
}
